var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWifiGreen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1_4972)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.2822 17.2068V20.4544C29.3445 20.4544 35.8966 27.0066 35.8966 35.0689H39.1443C39.1443 25.2041 31.147 17.2068 21.2822 17.2068ZM21.2822 22.8902V26.1378C26.2105 26.1378 30.2133 30.1405 30.2133 35.0689H33.4609C33.4609 28.3462 28.0049 22.8902 21.2822 22.8902ZM23.718 30.1974C23.072 30.1974 22.4524 30.454 21.9956 30.9108C21.5388 31.3676 21.2822 31.9871 21.2822 32.6331C21.2822 33.2791 21.5388 33.8987 21.9956 34.3554C22.4524 34.8122 23.072 35.0689 23.718 35.0689C24.364 35.0689 24.9835 34.8122 25.4403 34.3554C25.8971 33.8987 26.1537 33.2791 26.1537 32.6331C26.1537 31.9871 25.8971 31.3676 25.4403 30.9108C24.9835 30.454 24.364 30.1974 23.718 30.1974Z",
    fill: "#0DD0BA"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1_4972",
    x: -8.06077,
    y: -9.58621,
    width: 77.8276,
    height: 77.8276,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3.82759
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10.2069
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.164706 0 0 0 0 0.52549 0 0 0 0 0.898039 0 0 0 0.08 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1_4972"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1_4972",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWifiGreen);
export default __webpack_public_path__ + "static/media/wifi-green.ac3c07fd45d897578a1663d818e467f6.svg";
export { ForwardRef as ReactComponent };